/**
 * Champ de sélection de couleur avec étiquette et aperçu.
 *
 * Affiche un carré de couleur cliquable qui ouvre le sélecteur natif,
 * avec un libellé et la valeur hex affichée.
 */
const ColorField = (props: {
    label: string;
    value: string;
    onChange: (value: string) => void;
}) => (
    <div className="eb-color-field">
        <label className="eb-color-field-label">{props.label}</label>
        <div className="eb-color-field-input">
            <input
                type="color"
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
                className="eb-color-field-swatch"
            />
            <span className="eb-color-field-value">{props.value.toUpperCase()}</span>
        </div>
    </div>
);

export default ColorField;
